exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".animate-to-w-2[data-v-15366fe8]{animation:to-w-2-15366fe8 0.1s ease-in 0.4s forwards}@keyframes to-w-2-15366fe8{to{width:8px}}\n", ""]);

